import { Height } from "./Height";
import { Weight } from "./Weight";
import { LifeStatus } from "./LifeStatus";
import { FamilyDistance } from "./FamilyDistance";
import { NursingDegree } from "./NursingDegree";
import { BathAtHome } from "./BathAtHome";

const CareRecipientDetailType = Symbol();

export class CareRecipientDetail {
    [CareRecipientDetailType]: any;
    readonly height: Height;
    readonly weight: Weight;
    readonly weekdayLifeStatus: LifeStatus | undefined;
    readonly holidayLifeStatus: LifeStatus | undefined;
    readonly familyDistance: FamilyDistance | undefined;
    readonly nursingDegree: NursingDegree | undefined;
    readonly bathAtHome: BathAtHome | undefined;

    private constructor(
        height: Height,
        weight: Weight,
        weekdayLifeStatus: LifeStatus | undefined,
        holidayLifeStatus: LifeStatus | undefined,
        familyDistance: FamilyDistance | undefined,
        nursingDegree: NursingDegree | undefined,
        bathAtHome: BathAtHome | undefined,
    ) {
        this.height = height;
        this.weight = weight;
        this.weekdayLifeStatus = weekdayLifeStatus;
        this.holidayLifeStatus = holidayLifeStatus;
        this.familyDistance = familyDistance;
        this.nursingDegree = nursingDegree;
        this.bathAtHome = bathAtHome;
    }

    static from(
        height: Height,
        weight: Weight,
        weekdayLifeStatus: LifeStatus | undefined,
        holidayLifeStatus: LifeStatus | undefined,
        familyDistance: FamilyDistance | undefined,
        nursingDegree: NursingDegree | undefined,
        bathAtHome: BathAtHome | undefined,
    ): CareRecipientDetail {
        return new CareRecipientDetail(
            height,
            weight,
            weekdayLifeStatus,
            holidayLifeStatus,
            familyDistance,
            nursingDegree,
            bathAtHome
        );
    }

    static fromNothing() {
        return new CareRecipientDetail(
            Height.fromNothing(),
            Weight.fromNothing(),
            LifeStatus.fromNothing(),
            LifeStatus.fromNothing(),
            FamilyDistance.fromNothing(),
            NursingDegree.fromNothing(),
            BathAtHome.default()
        );
    }
}

export type CareRecipientDetailJson = {
    height: number | null,
    weight: number | null,
    weekdayLifeStatus: string,
    holidayLifeStatus: string,
    familyDistance: string,
    nursingDegree: string,
    bathAtHome: boolean
};

export const careRecipientDetailInitialState = {
    height: null,
    weight: null,
    weekdayLifeStatus: "",
    holidayLifeStatus: "",
    familyDistance: "",
    nursingDegree: "",
    bathAtHome: true
};
